import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pipelines",
  "use": "icon-pipelines-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pipelines\">\n  <g stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n    <path d=\"M7.05 16.948a7 7 0 0 0 11.919-4.29\" />\n    <path d=\"M9.172 15.535H5.636v3.536M16.95 7.051A7 7 0 0 0 5.03 11.342\" />\n    <path d=\"M14.828 8.465h3.536V4.929\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol